"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imgTypes = exports.default = void 0;
const imgTypes = exports.imgTypes = ['bmp', 'jpg', 'jpeg', 'png', 'tif', 'gif', 'pcx', 'tga', 'exif', 'fpx', 'svg', 'psd', 'cdr', 'pcd', 'dxf', 'ufo', 'eps', 'ai', 'raw', 'WMF', 'webp'];
var _default = exports.default = {
  name: 'YsImagePreview',
  props: {},
  data() {
    return {
      src: '',
      previewVisible: false
    };
  },
  methods: {
    show(src) {
      this.src = src;
      this.previewVisible = true;
    }
  }
};